import React, { PropTypes } from 'react'
import "./Price.css"

function formatPrice(val){
  return (val !== undefined) ? "$" + val : "";
}

const Price = ({ value }) => (
  <span className="price">
    {formatPrice(value)}
  </span>
)

Price.propTypes = {
  value:PropTypes.number,
}

export default Price